export const SIZES = {
  default: "default",
  large: "lg",
};
